export interface allStateData {
  serviceRequest: any
  dispatchId: string
}

export enum AllstateStatus {
  NEWJOB = 'NEW JOB',
  BOOKED = 'BOOKED',
  ASSIGNED = 'ASSIGNED',
  ENROUTE = 'EN-ROUTE',
  ENROUTEDISABLE = 'EN-ROUTE DISBLE',
  CANCELLED = 'CANCELLED',
  ONSITEEXCHANGE = 'ARRIVED ONSITE EXCHG',
  LOADEDEXCHANGE = 'LOADED EXCHG',
  ARRIVEDONSITE = 'ARRIVED ONSITE',
  GOAREQUIRED = 'GOA_REQ', //TODO: Confirm this isn't supposed to be 'GOA REQ'
  LOADED = 'LOADED',
  ENROUTEDROP = 'EN-ROUTE DROP',
  DROPLOCATION = 'DROP LOCATION',
  COMPLETED = 'COMPLETED',
  VEHICLESTORAGE = 'VEH STORAGE',
  SERVICEFAILURE = 'SVC_FAIL', //TODO: Confirm this isn't supposed to be 'SVC FAIL' - Shouldn't see this one in practice as per Allstate
}
